import type { InjectionKey } from 'vue';

export const MAIN_PAGE_NAVIGATION_LOADER_KEY: InjectionKey<() => void> = Symbol(
  'mainPageNavigationLoader',
);
